import React from 'react';
import Baumumfang from '../components/Baumumfang';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BaumumfangUnterpullendorf() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="baumumfang-unterpullendorf-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="baumumfang-unterpullendorf-heading">BAUMUMFANG</h1>
        </div>

        <Baumumfang ort="unterpullendorf" />
      </div>
    </div>
  );
}

export default BaumumfangUnterpullendorf;
